
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.1 18.012c0-1.2.1-2.5.1-3.7 0-.4-.1-1.6-.7-1.6h-1.2c.8-1.6 1.2-3.4 1-5.4 0-.3-.2-1.2-.7-1.2-3.5.5-5.7 3.3-6.5 6.5h-8.6c-.3-2.5-.6-5-.9-7.6-.3-2.1-1.6-.5-1.4.9.3 2.3.6 4.5.8 6.8h-2.4c-.5 0-.6 1.2-.6 1.5 0 1.4.1 2.9.1 4.3-.1.4 0 .9 0 1.3.1 1.7.1 3.4.2 5.1.1 1.8-.1 3.7.2 5.5.2 1.6 1.1 2.4 1.4 4.1 0 .1 0 .3.1.4.5 3.2.1 6.8.2 10s.2 6.4.2 9.5c0 .4.1 1.6.7 1.6h15.1c.6 0 .7-1.2.7-1.6.2-6.6.3-13.2.5-19.8.2-1.4 1.3-3.1 1.4-4.7.2-1.7.1-3.4.2-5.1.1-2.2.1-4.4.2-6.5-.1-.1-.1-.2-.1-.3zm-1.3-2.2v.8c-2.5 1-5.8.5-8.3.2-3.6-.5-6.6-.4-10 .6v-1.6h18.3zm-1-6.3c-.4 1.3-1.4 2.4-2.4 3.2H34c.7-1.6 2-2.8 3.8-3.2zm-1.3 43.5h-6.2v-9.1-6.8c0-.6-.2-1.6 0-2.1.7-2.1 5.7-5.4 6.6-.4-.1 6-.2 12.2-.4 18.4zm-7.6-17.2v17.1h-6.2c-.1-6.2 0-12.5-.5-18.6v-.1c.2-3.1 6.5-3.1 6.6 0v.4c.1.4.1.8.1 1.2zm9.5-5.4s-.2-.6-.8.7c0 .1-.1.1-.1.2-1.3-2.2-3.6-3.6-6.4-1.7-.7.5-1.2 1.1-1.5 1.8-.7-1.5-2-2.6-4-2.6-1.9 0-3.2 1-3.9 2.4-.3-.4-.9-1.3-.9-.9-.3-1.3 0-3.2-.1-4.4-.1-1.8-.1-3.5-.2-5.3 4.4-1.3 8-.6 12.5-.3 1.8.1 3.8.2 5.6-.4-.1 1.8-.1 3.7-.2 5.5.1 1.4.4 3.6 0 5z"}})])
          )
        }
      }
    